// Only the smaller sections That second fact is why the warning can be specific instead of ominous:
// "everything changes a little" would be both vaguer and less true than "the big field is
// untouched; the small one is re-derived".

export interface CombineCopyInput {
  /* * every section, largest first — the caller sorts by stored acres */
  fieldNames: string[];
  /* * the section whose values are bit-identical afterwards (the largest) */
  anchorName: string;
}

/* * The heading. Names what happens, not how. */
export const combineTitle = (n: number): string =>
  `Combine ${n} fields into one?`;

/*
 *
 * The body, as an ordered list of paragraphs. Each is a separate claim so the UI can weight them —
 * the irreversibility line is the one that must never be skimmed past.
 */
export function combineBody({
  fieldNames,
  anchorName,
}: CombineCopyInput): string[] {
  const others = fieldNames.filter((n) => n !== anchorName);
  const otherList =
    others.length === 1
      ? others[0]!
      : others.length === 2
        ? `${others[0]} and ${others[1]}`
        : `${others.slice(0, -1).join(", ")} and ${others[others.length - 1]}`;
  return [
    `${fieldNames.join(", ")} become one field made of ${fieldNames.length} sections. They keep their ground — nothing is deleted, and the combined field covers exactly what they covered together.`,
    // the honest description of re-derivation, made specific rather than ominous
    `Its maps are rebuilt on one grid across the whole field. ${anchorName} is the largest section, so its values come out unchanged; ${otherList} ${others.length === 1 ? "is" : "are"} re-calculated onto the combined grid, and ${others.length === 1 ? "its" : "their"} numbers can shift slightly.`,
    // "appears right away", which the engine cannot promise: before the 12.4 s re-grid, the job
    // WAITS for any work already running on the sources to drain, and that is legitimately tens of
    // minutes if one is mid-build (compute).
    "This runs in the background — you don’t have to wait here. The combined field appears in your list when it’s ready, and its soil-property maps refresh for a few minutes after that.",
    // the irreversibility, last, in its own paragraph, saying what cannot be got back
    "This cannot be undone. The original fields stop appearing in your list, and their saved zone designs stay in the version list but none stays active — the combined field starts without an active zone map.",
  ];
}

/* * The button. Says the action, not "OK". */
export const combineConfirmLabel = "Combine fields";
